  // You can write your custom Javascript here
  jQuery(document).ready(function () {
    // Shop Pay Installments Handling
    function initShopPayInstallments() {
      jQuery('.shop-pay-installments').each(function() {
        var $banner = jQuery(this);
        var variantPrice = parseInt($banner.data('variant-price')) || 0;
        var currency = '$'; // Default to $ since you removed currency data attribute
        
        // Show banner only for eligible amounts ($50-$3000 USD equivalent)
        var priceInDollars = variantPrice / 100;
        
        if (priceInDollars >= 50 && priceInDollars <= 3000) {
          var installmentAmount = (priceInDollars / 4).toFixed(2);
          
          // Update the installment amount display
          $banner.find('.installments-amount').text(currency + installmentAmount);
          
          // Show the banner
          $banner.show();
          
          // Add click handler for learn more - ensure we're targeting the right element
          $banner.find('.installments-learn-more').off('click').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            console.log('Learn more clicked'); // Debug log
            showInstallmentsModal(priceInDollars, installmentAmount, currency);
          });
        } else {
          // Hide banner for ineligible amounts
          $banner.hide();
        }
      });
    }
    
    // Show installments information modal
    function showInstallmentsModal(totalPrice, installmentAmount, currency) {
      var modalHtml = `
        <div class="installments-modal-overlay">
          <div class="installments-modal">
            <div class="installments-modal-header">
              <h3>Shop Pay Installments</h3>
              <button class="installments-modal-close">&times;</button>
            </div>
            <div class="installments-modal-body">
              <p><strong>Pay ${currency}${totalPrice.toFixed(2)} in 4 interest-free payments of ${currency}${installmentAmount}</strong></p>
              <ul>
                <li>No interest or fees when you pay on time</li>
                <li>Payments every 2 weeks</li>
                <li>Available for orders $50-$3,000</li>
                <li>Must have a Shop Pay account</li>
              </ul>
              <p><small>Subject to eligibility. Complete terms at checkout.</small></p>
            </div>
          </div>
        </div>
      `;
      
      jQuery('body').append(modalHtml);
      
      // Close modal handlers
      jQuery('.installments-modal-overlay').on('click', function(e) {
        if (e.target === this) {
          jQuery(this).remove();
        }
      });
      
      jQuery('.installments-modal-close').on('click', function() {
        jQuery('.installments-modal-overlay').remove();
      });
      
      // Close on escape key
      jQuery(document).on('keydown.installments', function(e) {
        if (e.keyCode === 27) {
          jQuery('.installments-modal-overlay').remove();
          jQuery(document).off('keydown.installments');
        }
      });
    }
    
    // Update installments when variant changes
    jQuery(document).on('change', 'select[name="id"], input[name="id"]', function() {
      var variantId = jQuery(this).val();
      var $option = jQuery(this).find('option[value="' + variantId + '"]');
      
      if ($option.length && $option.data('price')) {
        jQuery('.shop-pay-installments').attr('data-variant-price', $option.data('price'));
        initShopPayInstallments();
      }
    });
    
    // Listen for variant changes from other sources
    jQuery(document).on('variant:change', function(event, variant) {
      if (variant && variant.price) {
        jQuery('.shop-pay-installments').attr('data-variant-price', variant.price);
        initShopPayInstallments();
      }
    });
    
    // Initialize on page load
    initShopPayInstallments();
    
    // jQuery('.radio.radio--color.disabled').parent().remove();

  // Wedding Date - Required
  if (!jQuery("#field-date").val()) {
    if ($('body').hasClass('template-cart')) {
      jQuery("#field-date").parent().find(".error").slideDown();
      jQuery("#field-date").closest('.form__row').find(".wedding-label").addClass('date-error');
    }
  }
  // Check if error came from checkout
  if (window.location.hash === "#wedding-date") {
    if (!jQuery("#field-date").val()) {
      jQuery(".btn--checkout").attr("disabled", true);
      jQuery(".wedding-date-picker").find(".error").slideDown();
      jQuery(".wedding-date-picker").find(".wedding-label").addClass('date-error');
      jQuery(".wedding-date-picker").addClass('wedding__error');
      document.querySelector(".wedding-date-picker").scrollIntoView({
        behavior: "smooth",
      });
      setTimeout(function () {
        jQuery("#field-date").trigger("blur").trigger("focus");
      }, 1000);
    }
  }
  jQuery("#field-date").on("change", function (e) {
    if (e.target.value) {
      jQuery(".btn--checkout").attr("disabled", false);
      jQuery(e.target).parent().find(".error").slideUp();
      jQuery(e.target).closest('.form__row').find(".wedding-label").removeClass('date-error');
      jQuery(".wedding__controls").removeClass('wedding__error');
      // Came from checkout, focus on button after selection
      if (window.location.hash === "#wedding-date") {
        setTimeout(function () {
          jQuery(".btn--checkout").trigger("focus");
        }, 1000);
      }
    } else {
      jQuery(".btn--checkout").attr("disabled", true);
      jQuery(e.target).parent().find(".error").slideDown();
      jQuery(e.target).closest('.form__row').find(".wedding-label").addClass('date-error');
      jQuery("#field-date").trigger("blur").trigger("focus");
      jQuery(".wedding__controls").addClass('wedding__error');
    }
  });

  $(".em-wdgt-products").each(function (elmnt) {
    $(this).html('<img src="//cdn.shopify.com/s/files/1/0300/7401/t/180/assets/bc-sf-filter-loading.gif" />');
    render_products($(this));
  });

  function render_products(elmnt) {
    let widget = $(elmnt);
    let handle = widget.data("collection");
    let color = lower_case(widget.data("color"));
    let limit = widget.data("size");
    $.get("https://www.kennedyblue.com/collections/" + handle + "/products.json", function (data) {
      let products = data.products;
      let html_data = '<div class="products-grid">';
      for (var i = 0; i < products.length; i++) {
        if (i >= limit) {
          break;
        }
        html_data += get_product_data(products[i], color);
      }
      html_data += '</div>';
      widget.html(html_data);
    });
  }

  function get_product_data(product, color) {
    let variants = product['variants'];
    let variant = variants[0];
    if (color != null && color != undefined) {
      for (var i = 0; i < variants.length; i++) {
        if (lower_case(variants[i]['option1']) == color || lower_case(variants[i]['option2']) == color || lower_case(variants[i]['option3']) == color) {
          variant = variants[i];
          break;
        }
      }
    }
    let product_url = "/products/" + product["handle"] + "?variant=" + variant["id"];
    return '<div class="product-grid"><div class="product-item-inner"><div class="product-item-image"><a href="' + product_url + '"><img src="' + variant['featured_image']['src'] + '" /></a></div><div class="product-bottom"><a href="' + product_url + '" class="product-item-title">' + product['title'] + '</a><p class="product-item-price"><span class="product-item-regular-price">$&nbsp;' + variant['price'] + '</span></p></div></div></div>';
  }

  function lower_case(str) {
    if (str == null || str == undefined) {
      return str;
    }

    return str.toString().toLowerCase();
  }
});

$(document).on('click', '[name="checkout"]', function (e) {
  if (!$("#field-date").val()) {
    e.preventDefault();
    $(this).attr("disabled", true);
    $(this).closest('form').find(".error").slideDown();
    $(this).closest('form').find(".wedding-label").addClass('date-error');
    $("#field-date").trigger("blur").trigger("focus");
    $(".wedding__controls").addClass('wedding__error');
  }
});


if (document.querySelector('.nav .nav__dropdown .nav__dropdown')) {
  document.querySelectorAll('.nav .nav__dropdown .nav__dropdown').forEach(el => {
    if (jQuery(window).width() >= 768) {
      let cont = el.closest('.shell').querySelector('.dropdown-menu');
      let contH = jQuery(cont).outerHeight(true);
      let titleH = jQuery(cont.querySelector('.dropdown-menu-title')).outerHeight(true);
      let linkH = jQuery(el.closest('.nav__item').querySelector('a')).outerHeight(true);
      el.style.marginTop = "-" + (titleH + linkH - 18) + "px";
      el.style.minHeight = contH + "px";
    }
  });
}

if (document.querySelector('.nav .nav__dropdown .nav__dropdown')) {
  document.querySelectorAll('.nav .nav__dropdown .nav__dropdown').forEach(el => {
    if (jQuery(window).width() < 768) {
      let links = el.closest('.nav__item').querySelectorAll('&> a');
      if(links.length > 0) {
        links.forEach(link => {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            //link.classList.toggle('is-active');
            showNavDropdownsForMobile(link)
          });
        });
      }
    }
  });
}

if(typeof showNavDropdownsForMobile == "undefined") {
  function showNavDropdownsForMobile($clickedElement) {
    let mobileWidth = 767;
    $clickedElement = jQuery($clickedElement);
    if (jQuery(window).width() > mobileWidth) {
      $clickedElement.parent().addClass('is-active').siblings().removeClass('is-active');
    } else {
      if(!$clickedElement.hasClass('is-active')) {
        $clickedElement.addClass('is-active').next('.nav__dropdown').slideDown().closest('li').siblings().find('.is-active').removeClass('is-active').next('.nav__dropdown').slideUp();
      }
      else {
        $clickedElement.removeClass('is-active').next('.nav__dropdown').slideUp().closest('li').siblings().find('.is-active').removeClass('is-active').next('.nav__dropdown').slideUp();
      }
    }
  }
}


if(typeof genFx == "undefined") {
  function genFx( type, includeWidth ) {
    var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
    var which,
      i = 0,
      attrs = { height: type };

    // If we include width, step value is 1 to do all cssExpand values,
    // otherwise step value is 2 to skip over Left and Right
    includeWidth = includeWidth ? 1 : 0;
    for ( ; i < 4; i += 2 - includeWidth ) {
      which = cssExpand[ i ];
      attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
    }

    if ( includeWidth ) {
      attrs.opacity = attrs.width = type;
    }

    return attrs;
  }
}

// Generate shortcuts for custom animations
jQuery.each( {
  slideDown: genFx( "show" ),
  slideUp: genFx( "hide" ),
  slideToggle: genFx( "toggle" ),
  fadeIn: { opacity: "show" },
  fadeOut: { opacity: "hide" },
  fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
  jQuery.fn[ name ] = function( speed, easing, callback ) {
    return this.animate( props, speed, easing, callback );
  };
} );

/* WS v17 (31 Jul): strip stray currency-code suffix ("USD") from prices.
   Investigated live: the shop's own money_format setting is clean
   ("${{amount}}", confirmed via window.Shopify.money_format), and a fresh
   fetch() of a PDP's raw server-rendered HTML (before any theme/app JS
   runs) shows a plain "$1,709.00" with no currency code. So this is not a
   Shopify admin currency-format setting, and it's not hardcoded anywhere
   in this theme's Liquid/JS. Yet the live, fully-loaded DOM shows
   "$1,709.00 USD" on PDP prices and Bold Product Options' addon prices
   ("(+ $30.00 USD)") - confirmed this text is being added client-side,
   after load, by a third-party app script (candidates seen on-page:
   Bold Product Options' hybrid buy-box rebuild, and Boost's multi-currency
   product cache). Rather than depend on identifying/patching that specific
   app (which could change), this scrubs any trailing 3-letter ISO currency
   code off rendered price text wherever it shows up, on load and whenever
   later JS (variant swaps, Bold rebuilds, AJAX cart updates) rewrites a
   price element. */
(function(){
  // Matches a trailing ISO code like " USD" even when it's the last thing
  // before a closing paren, e.g. Bold Product Options' "(+ $30.00 USD)"
  // addon price labels - the lookahead leaves the ")" in place so only the
  // code itself is removed.
  var CODE_RE = /\s+[A-Z]{3}\b(?=\)?\s*$)/;

  function stripCurrencyCode(el) {
    if (!el || el.nodeType !== 1) return;
    // Only touch leaf-ish nodes so we don't mangle elements that contain
    // other markup (icons, nested spans) alongside the price text.
    if (el.children.length) return;
    var text = el.textContent;
    if (text && CODE_RE.test(text)) {
      el.textContent = text.replace(CODE_RE, '');
    }
  }

  function sweep(root) {
    root = root || document;
    var nodes = root.querySelectorAll ? root.querySelectorAll('.money, .addOn, .price__amount, .price-item') : [];
    for (var i = 0; i < nodes.length; i++) {
      stripCurrencyCode(nodes[i]);
      // .price__amount often wraps a child .money span - handled by the
      // selector above already matching both, but guard against a
      // single-text-node wrapper too.
    }
    if (root.nodeType === 1) stripCurrencyCode(root);
  }

  jQuery(document).ready(function(){
    sweep(document);

    if (window.MutationObserver) {
      /* WS v18 (31 Jul): the v17 observer only acted on ADDED ELEMENT
         nodes (nodeType 1) inside a childList mutation, and on the
         parentElement of a characterData mutation. That misses the exact
         case that matters here: Bold's buy-box rebuild sets the price via
         `span.textContent = "$1,709.00 USD"`, which removes the span's old
         text node and inserts a NEW text node (nodeType 3) as a childList
         mutation on the span itself. The old handler's nodeType===1 check
         skipped that added text node, and never looked at m.target (the
         span) directly - so the rewrite was invisible to the observer.
         Confirmed live: after shipping v17, weddingshoppeinc.com/products/
         selby-rae-diamond-ava-wedding-dress still showed "$1,709.00 USD"
         even with custom.js loaded, because this exact case slipped
         through. Fix: on every childList mutation, also run
         stripCurrencyCode directly on m.target (the element whose children
         changed), regardless of what node types were added/removed. */
      var observer = new MutationObserver(function(mutations){
        mutations.forEach(function(m){
          if (m.type === 'characterData' && m.target && m.target.parentElement) {
            stripCurrencyCode(m.target.parentElement);
          }
          if (m.type === 'childList') {
            if (m.target && m.target.nodeType === 1) {
              stripCurrencyCode(m.target);
            }
            m.addedNodes && m.addedNodes.forEach(function(node){
              if (node.nodeType === 1) {
                sweep(node);
              }
            });
          }
        });
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });

      // Belt-and-suspenders: third-party price rewrites on this theme have
      // now twice slipped past mutation-based detection in ways that were
      // only obvious once live. A short-lived polling sweep guarantees
      // convergence regardless of how the next app happens to mutate the
      // DOM, without permanently polling the page.
      var sweepAttempts = 0;
      var intervalId = setInterval(function(){
        sweep(document);
        sweepAttempts++;
        if (sweepAttempts >= 15) clearInterval(intervalId);
      }, 400);
    }
  });
})();

/* WS v17 (31 Jul): recolor Stamped review-star icons to the brand palette.
   Jimmy: collection-page review stars should look on-brand. A plain
   ws-brand.css color override doesn't work here - confirmed live that
   Stamped writes each star icon's color as an INLINE style with its own
   !important (style="color:#f48b8c !important;"), which no external
   stylesheet rule can beat regardless of specificity. Only rewriting that
   same inline declaration via JS can override it, so this sweeps every
   star icon (on collection cards AND the PDP review widget - it's the same
   Stamped markup in both places) and replaces the inline color: filled
   stars (.stamped-fa-star) get the lipstick accent, empty stars
   (.stamped-fa-star-o) get a quiet neutral gray, both still set with
   !important so Stamped's own re-renders don't win the tie. Scoped to
   .stamped-starrating so unrelated Stamped icons (camera, share, thumbs
   up/down, search) in the full review module keep their original color.

   WS v19 (31 Jul): Jimmy reported stars "at the bottom" of the PDP (the
   individual review entries, e.g. Cate's/Jessica's reviews) were still
   pink. Root cause: those specific stars sit inside a container classed
   "stamped-starratingS" (plural - .stamped-review-header-starratings), a
   DIFFERENT class token than "stamped-starrating" (singular) used by the
   other 3 Stamped widget instances (title badge, big score summary,
   review-submission picker) - .stamped-starrating never matched it.
   Switched to a substring match on the class attribute so both the
   singular and plural containers (and any other "stamped-starrating*"
   variant Stamped ships) are covered by one sweep. Also now repaints the
   rating-breakdown histogram bars, which get their pink from a
   background-color rather than the star icon's color. */
jQuery(document).ready(function(){
  var FILLED_COLOR = '#6A3B3F';
  var EMPTY_COLOR = '#D8D3D0';

  function paintStars(root) {
    root = root || document;
    if (!root.querySelectorAll) return;
    var filled = root.querySelectorAll('[class*="stamped-starrating"] .stamped-fa-star:not(.stamped-fa-star-o)');
    var empty = root.querySelectorAll('[class*="stamped-starrating"] .stamped-fa-star-o');
    for (var i = 0; i < filled.length; i++) {
      filled[i].style.setProperty('color', FILLED_COLOR, 'important');
    }
    for (var j = 0; j < empty.length; j++) {
      empty[j].style.setProperty('color', EMPTY_COLOR, 'important');
    }
    var histogramBars = root.querySelectorAll('.summary-rating-bar-content');
    for (var h = 0; h < histogramBars.length; h++) {
      histogramBars[h].style.setProperty('background-color', FILLED_COLOR, 'important');
    }
  }

  paintStars(document);

  if (window.MutationObserver) {
    var starObserver = new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        m.addedNodes && m.addedNodes.forEach(function(node){
          if (node.nodeType === 1) {
            paintStars(node);
          }
        });
        // WS v18: if Stamped ever repaints an EXISTING star icon's inline
        // style (rather than inserting a fresh one) this catches it too -
        // same class of race as the currency-code fix below needed.
        if (m.type === 'attributes' && m.target && m.target.nodeType === 1) {
          paintStars(m.target.parentElement || document);
        }
      });
    });
    starObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }

  // Belt-and-suspenders, same rationale as the price-currency sweep below:
  // guarantees the stars converge to brand color even if Stamped's widget
  // loads/re-renders in a way the observer doesn't cleanly catch.
  //
  // WS v20 (31 Jul): widened from 15x/400ms (~6s) to 40x/500ms (~20s).
  // Jimmy reported the big "5.0" summary stars still pink after v19 while
  // the (CSS-only) histogram bars right next to them were correctly fixed -
  // that split is the signature of the summary widget's stars rendering
  // later than this sweep's original 6s window (the full "PRODUCT REVIEWS"
  // block often lazy-loads lower on the page), not a selector gap, since
  // .stamped-summary-starrating is already covered by the selector above
  // and verified live to work once painted. Longer window costs nothing at
  // rest and closes that timing gap.
  var starSweepAttempts = 0;
  var starIntervalId = setInterval(function(){
    paintStars(document);
    starSweepAttempts++;
    if (starSweepAttempts >= 40) clearInterval(starIntervalId);
  }, 500);
});

/* WS v23 (31 Jul): lock the Contact-for-Pricing $ range against bundle.min.js
   stomping it back to the plain price (or blank) after render. Root cause,
   confirmed by reading bundle.js's product.js module directly: the variant
   <select id="product-select"> stores a formatted price on every <option
   data-price="...">, and there are 3 separate call sites in that module that
   do $('.js-price').html($productSelect.find('option:selected').data('price'))
   - one fires unconditionally on page load for any product with more than
   one color/material option (no user interaction needed), the other two fire
   on every option/color change. v22 fixed the data-price VALUE itself (made
   it carry the range markup for hidetag+range-toggle-on products instead of
   the plain price), which handles the page-load case - but Jimmy reported it
   still breaking after that ("range showing up, but in the wrong spot" /
   "contact for price isn't showing up" - a blank .js-price happens when
   $productSelect.find('option:selected') briefly matches nothing mid-
   transition, since jQuery's .html(undefined) empties the element). Rather
   than keep auditing bundle.js's timing for more call sites we might still
   be missing, this applies the same defense-in-depth pattern already proven
   for the review-star color fix above: watch the locked price element and
   restore the correct range the instant anything else changes it, regardless
   of which third-party script did it or why. sections/product-template.liquid
   marks the element with data-ws-range-lock="1" and carries the correct
   low/high/tooltip values in data attributes, so this never has to guess or
   duplicate the Liquid math - it just enforces whatever Liquid already
   decided was correct for this product. */
jQuery(document).ready(function(){
  function buildRangeHtml(low, high, tooltip) {
    return '<span class="ws-price-range-value">' + low + ' - ' + high + '</span>'
      + '<span class="ws-price-range-info" tabindex="0">'
      + '<span class="ws-price-range-icon" aria-hidden="true">?</span>'
      + '<span class="ws-price-range-tooltip">' + (tooltip || '') + '</span>'
      + '</span>';
  }

  function enforceRange(el) {
    if (!el || el.nodeType !== 1 || el.getAttribute('data-ws-range-lock') !== '1') return;
    var low = el.getAttribute('data-ws-range-low');
    var high = el.getAttribute('data-ws-range-high');
    if (!low || !high) return;
    var valueSpan = el.querySelector('.ws-price-range-value');
    var expectedText = low + ' - ' + high;
    if (!valueSpan || valueSpan.textContent !== expectedText) {
      el.innerHTML = buildRangeHtml(low, high, el.getAttribute('data-ws-range-tooltip'));
    }
  }

  function sweepRange(root) {
    root = root || document;
    if (!root.querySelectorAll) return;
    var locked = root.querySelectorAll('[data-ws-range-lock="1"]');
    for (var i = 0; i < locked.length; i++) {
      enforceRange(locked[i]);
    }
    // In case the locked element itself is the root passed in (e.g. from an
    // observer's m.target), not just a container of one.
    if (root.nodeType === 1) enforceRange(root);
  }

  sweepRange(document);

  if (window.MutationObserver) {
    var rangeObserver = new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        // Same lesson as the currency-code fix above: bundle.min.js's
        // $('.js-price').html(...) replaces the element's children in one
        // childList mutation ON THE ELEMENT ITSELF, so m.target (not just
        // m.addedNodes) has to be checked directly or this never fires.
        if (m.type === 'childList' && m.target && m.target.nodeType === 1) {
          enforceRange(m.target);
        }
        m.addedNodes && m.addedNodes.forEach(function(node){
          if (node.nodeType === 1) sweepRange(node);
        });
      });
    });
    rangeObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Belt-and-suspenders: bundle.js's page-load price sync and the color-
  // swatch change cascade both fire within the first second or two, but
  // there's no guarantee some other app script doesn't rewrite it later
  // (Bold Product Options, Boost's variant sync, etc. all touch price
  // elements elsewhere in this theme). Short, tight interval since this is a
  // pricing-accuracy issue, not cosmetic.
  var rangeSweepAttempts = 0;
  var rangeIntervalId = setInterval(function(){
    sweepRange(document);
    rangeSweepAttempts++;
    if (rangeSweepAttempts >= 25) clearInterval(rangeIntervalId);
  }, 200);
});

jQuery(document).ready(function($){
  // WS v25 (31 Jul): Jimmy - "replace the Color: All Ivory with a drop down
  // like kennedy blue and then have the color chips below it. This then
  // allows customers to pick the color chip or the name." Referenced
  // kennedyblue.com's own PDP: it's a custom button+listbox combobox
  // (.kb-color-dd) sitting above the existing swatch grid, not a native
  // <select>. The dropdown markup (.ws-color-dd) and its
  // <button role="option"> list are built in sections/product-template.liquid
  // (both the AHTO/try-on and standard branches) and products-custom.js,
  // always alongside the swatch <li> chips they mirror, from the same data,
  // so the two lists can't drift out of sync - see the comments at those
  // build sites. This block is ONLY the interaction layer: open/close the
  // panel, and keep the dropdown and the chips pointing at the same color no
  // matter which one the customer used to pick it.
  //
  // Deliberately does NOT duplicate any variant-selection logic. Picking a
  // dropdown option proxies into a real click on the matching chip's label,
  // so the existing chip-click handlers already in bundle.js and
  // products-custom.js - variant matching, price, slider images, the
  // out-of-stock state - keep running through the one code path they always
  // did. This is the same reasoning as the wsa-js-book fix earlier this
  // round: centralize behavior in the code that already owns it instead of
  // re-implementing it a second time somewhere else.

  function closeAllColorDds(exceptEl) {
    $('.ws-color-dd.open').each(function(){
      if (this === exceptEl) return;
      $(this).removeClass('open').find('.ws-color-dd__trigger').attr('aria-expanded', 'false');
    });
  }

  // Reads whichever chip is currently checked in a color row and applies
  // that same color to the dropdown: swatch-preview fill on the trigger,
  // and the checkmark (aria-selected) on the matching panel option. Called
  // after a direct chip click, after a dropdown pick (which itself lands
  // here via the same 'change' event, since it proxies a real click), and
  // on the 'colors-row-updated' event both product-template.liquid and
  // products-custom.js already fire once their chip list for a row is
  // (re)built - including on first page load.
  function syncColorDd($row) {
    var $dd = $row.find('.ws-color-dd');
    if (!$dd.length) return;

    var $checkedInput = $row.find('.list-radios--colors input:checked');
    if (!$checkedInput.length) return;

    var handle = $checkedInput.val();
    var $options = $dd.find('.ws-color-dd__panel .ws-color-dd__option');
    $options.attr('aria-selected', 'false');

    var $match = $options.filter('[data-handle="' + handle + '"]');
    if (!$match.length) return;
    $match.attr('aria-selected', 'true');

    var $swatch = $match.find('.ws-color-dd__option-swatch');
    var fill = $swatch.css('background-image');
    if (!fill || fill === 'none') fill = $swatch.css('background-color');
    $dd.find('.ws-color-dd__trigger-swatch').css('background', fill);
  }

  // Open/close the panel from its trigger button.
  $(document).on('click', '.ws-color-dd__trigger', function(e){
    e.preventDefault();
    var $dd = $(this).closest('.ws-color-dd');
    var wasOpen = $dd.hasClass('open');
    closeAllColorDds($dd[0]);
    $dd.toggleClass('open', !wasOpen);
    $(this).attr('aria-expanded', wasOpen ? 'false' : 'true');
  });

  // Picking a dropdown option clicks the matching chip's label - see the
  // comment at the top of this block for why that, rather than duplicating
  // the selection logic, is deliberate.
  $(document).on('click', '.ws-color-dd__option', function(){
    var $option = $(this);
    var $dd = $option.closest('.ws-color-dd');
    var $row = $dd.closest('.colors-row');
    var $chipLabel = $row.find('.list-radios--colors label[data-handle="' + $option.attr('data-handle') + '"]');

    if ($chipLabel.length) $chipLabel.trigger('click');

    $dd.removeClass('open').find('.ws-color-dd__trigger').attr('aria-expanded', 'false');
  });

  $(document).on('change', '.list-radios--colors input', function(){
    syncColorDd($(this).closest('.colors-row'));
  });

  $(document).on('colors-row-updated', function(){
    $('.colors-row').each(function(){ syncColorDd($(this)); });
  });

  // Standard combobox dismissal: click elsewhere, or Escape.
  $(document).on('click', function(e){
    if (!$(e.target).closest('.ws-color-dd').length) closeAllColorDds();
  });
  $(document).on('keydown', function(e){
    if (e.key === 'Escape') closeAllColorDds();
  });
});

jQuery(document).ready(function($){
  // WS v26 (31 Jul): resolve the PDP "Try It On At Home" button to the EXACT
  // $10 sample product on kennedyblue.com. Markup + full design rationale in
  // snippets/ws-kb-fulfillment-buttons.liquid. Verified live (31 Jul) by
  // running this exact candidate/probe logic from weddingshoppeinc.com
  // against KB's real endpoints across all 179 bridesmaid dresses: 141
  // resolve to an existing sample-* product, 38 fall back (Platinum line has
  // no KB samples - confirmed 404s). CORS on KB's public product JSON is
  // open (tested), so this runs client-side with no server or app.
  //
  // Existence (2xx) is the ONLY gate. Deliberately NOT gated on the JSON's
  // "available" flag: KB sample PDPs are orderable with restock-cycle
  // messaging ("IN-STOCK: 3-5 BUSINESS DAYS") even while the raw .js
  // endpoint reports available:false on every variant - checked live on
  // sample-kylie. Gating on that flag would wrongly hide the button for
  // ~96% of dresses.
  //
  // WS v27 (31 Jul): mothers-dress "strict" mode (button hidden until an
  // exact sample resolved) removed per Jimmy - buttons are now bridesmaid-
  // PDP-only, so every button always has a valid collection fallback and
  // renders visible from the start.
  var $tryonBtns = $('[data-ws-kb-tryon]');
  if (!$tryonBtns.length) return;

  var KB = 'https://www.kennedyblue.com';
  var UTM = '?utm_source=weddingshoppeinc&utm_medium=referral&ref=weddingshoppe&utm_campaign=home-try-on';

  function candidatesFor(handle, vendor, override) {
    var list = [];
    if (override) list.push(override);
    var base = handle.replace(/^kennedy-blue-/, '')
                     .replace(/-bridesmaid-dress$/, '')
                     .replace(/-dress$/, '');
    list.push('sample-' + base);
    // KB fabric lines have their own samples (sample-sloane vs
    // sample-sloane-luxe-satin); WS encodes fabric in the vendor name.
    if (/satin/i.test(vendor) && base.indexOf('luxe-satin') === -1) {
      list.push('sample-' + base + '-luxe-satin');
    }
    if (/velvet/i.test(vendor) && base.indexOf('velvet') === -1) {
      list.push('sample-' + base + '-stretch-velvet');
      list.push('sample-' + base + '-velvet');
    }
    return list;
  }

  function probe(candidates, i, done) {
    if (i >= candidates.length) return done(null);
    fetch(KB + '/products/' + candidates[i] + '.js')
      .then(function(r){ return r.ok ? candidates[i] : null; })
      .then(function(hit){
        if (hit) return done(hit);
        probe(candidates, i + 1, done);
      })
      .catch(function(){ probe(candidates, i + 1, done); });
  }

  $tryonBtns.each(function(){
    var el = this;
    var $el = $(el);
    var cands = candidatesFor(
      $el.attr('data-ws-kb-product-handle') || '',
      $el.attr('data-ws-kb-vendor') || '',
      $el.attr('data-ws-kb-override')
    );
    probe(cands, 0, function(found){
      if (found) {
        el.href = KB + '/products/' + found + UTM;
      }
      // No exact sample: the button keeps its collection-page fallback href
      // from Liquid.
    });
  });
});